// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hint-message_wrapper__yzt9L","childrenWrapper":"hint-message_childrenWrapper__N_J5f","close":"hint-message_close__swWg4","message":"hint-message_message__xeuza"};